<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
            <a
                v-on   = "{ ...tooltip }"
                @click.stop = "onClick"
                class="ml-2"
            >
                <div class="b-button">
                    <div class="b-icon">
                        <v-icon color="primary">mdi-plus-circle</v-icon>
                    </div>
                    <div class="b-label">
                        <div style="margin-top: -7px;">
                            {{ label }}
                        </div>
                    </div>
                </div>
            </a>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "CHeaderButton",

    props: {
        label: {

        },

        tooltip: {

        },
    },

    methods: {
        onClick() {
            this.$emit("click")
        }
    }
}
</script>

<style lang="scss" scoped>

.b-button {
    display: flex;
    height: 18px;
    font-size: 11px;
    margin-top: 6px;
    width: 50px;
    border-radius: 2px;
    border-width: 1px;
    border-style: solid;
    border-color: lightgray!important;
    background-color: white;
}

.b-icon {
    margin-top: -7px;
    padding-left: 1px;
    padding-right: 1px;
}

.b-label {
    width: 100%;
    margin-top: 1px;
    margin-right: 1px;
    text-align: center;
    height: 14px;
    border-radius: 2px;
    color: white;
    background-color: var(--v-primary-base)!important;
}

</style>